import WebApp from '@twa-dev/sdk'

export function getTelegramUserId(): string {
  const user = WebApp.initDataUnsafe?.user
  if (user?.id) {
    return String(user.id)
  }
  const webUserId = sessionStorage.getItem('web3_miniapp_user_id')
  if (webUserId) return webUserId
  return 'dev_user'
}

export function getTelegramUsername(): string {
  const user = WebApp.initDataUnsafe?.user
  return user?.username || user?.first_name || 'dev_user'
}
